<div class="rx-intuitive-tooth-editor-header">
	<div class="rx-intuitive-tooth-editor-header__title-row">
		<div class="rx-intuitive-tooth-editor-header__title-left">
			<rx-intuitive-indication-badge
				*ngIf="isIndicationVisible"
				[indication]="indicationId"
			/>
			<span class="rx-intuitive-tooth-editor-header__tooth-label">
				{{ 'ToothEditor.ToothNumberHash' | translate }}{{ toothNumbersLabel }}
			</span>
		</div>
		<button
			*ngIf="canDelete"
			tlkButton
			class="rx-intuitive-tooth-editor-header__indication-delete-btn"
			variant="ghost"
			size="l"
			[attr.aria-label]="'ToothEditor.Delete' | translate"
			[disabled]="!canDelete"
			(click)="signalDelete()"
		>
			<tlk-delete-icon />
		</button>
	</div>
</div>
<rx-intuitive-tooth-editor-body
	*ngIf="!shouldHideProperties"
	[teeth]="teeth"
	[isReadOnly]="!canEdit"
	[teethFlatOverride]="teethFlat$ | async"
	(crownFormChanged)="onBodyCrownFormChanged($event)"
	(additionalInfoApplied)="onBodyAdditionalInfoApplied($event)"
	(clearDisabledFields)="onBodyClearDisabledFields($event)"
></rx-intuitive-tooth-editor-body>
